import { render, staticRenderFns } from "./AccountBill.vue?vue&type=template&id=4c056962&scoped=true&"
import script from "./AccountBill.vue?vue&type=script&lang=js&"
export * from "./AccountBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c056962",
  null
  
)

export default component.exports